import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppButtonComponent } from '../button/app-button.component';
import { Subscription } from 'rxjs';
import { UiService } from '../../../core/services/ui.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-contact-us-modal',
  standalone: true,
  imports: [CommonModule, AppButtonComponent],
  templateUrl: './contact-us-modal.component.html',
  styleUrls: ['./contact-us-modal.component.scss'],
})
export class ContactUsModalComponent implements OnInit, OnDestroy {
  isVisible = false;
  private sub = new Subscription();

  // Brand-aware contact details (SK12 values are unchanged).
  private readonly isTll = environment.brand === 'tll';
  readonly supportEmail = this.isTll ? 'info@thelearningliaisons.com' : 'support@simplek12.com';
  readonly supportPhone = this.isTll ? '407-796-5191' : '(800) 393-4636';
  readonly supportPhoneTel = this.isTll ? '+14077965191' : '+18003934636';
  private readonly ticketUrl = this.isTll
    ? 'https://www.thelearningliaisons.com/contact'
    : 'https://www.simplek12.com/contact';

  constructor(private uiService: UiService) {
    this.sub.add(this.uiService.contactModal$.subscribe((val) => (this.isVisible = val)));
  }

  ngOnInit(): void {
    // The hosted B2C sign-up page can't open this Angular modal directly, so its "Contact us" link
    // sends the user here with ?contactUs=1 — honour it, then strip the param so a refresh won't reopen it.
    try {
      const params = new URLSearchParams(window.location.search);
      if (params.get('contactUs') === '1') {
        this.uiService.openContactModal();
        params.delete('contactUs');
        const qs = params.toString();
        window.history.replaceState({}, '', window.location.pathname + (qs ? `?${qs}` : '') + window.location.hash);
      }
    } catch {
      /* ignore */
    }
  }

  onClose(): void {
    this.uiService.closeContactModal();
  }

  submitTicket(): void {
    window.open(this.ticketUrl, '_blank');
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
